export default __webpack_public_path__ + "static/media/gift-card.077dc866.svg";